import * as React from 'react'
import Input from 'reactstrap/lib/Input'
import DateRange from '../../../../share/components/DateRange/DateRange';
import { IDateRange } from 'src/share/hooks/useDateRangeFilter';
import useDebounce from 'src/share/hooks/useDebounce';

interface ILogsTableSubHeaderProps {
  dateRange: IDateRange;
  onDateChanged: (date) => void;
  onFocusChanged: ({ focus }) => void;
  onSearched: (text: string) => void;
}

function LogsTableSubHeader(props: ILogsTableSubHeaderProps): React.ReactElement {
  const {  dateRange, onDateChanged, onFocusChanged, onSearched } = props;
  const [ filterText, setFilterText] = React.useState("");
  const debouncedSFilterText = useDebounce(filterText, 500);
  React.useEffect(() => {
    onSearched(debouncedSFilterText);
  }, [debouncedSFilterText]);
  return (
    <div className="logs__sub-header">
      <Input
        className="search"
        placeholder="Search"
        onChange={(e) => setFilterText(e.target.value)}
        value={filterText}
      />
      <DateRange
        startDate={dateRange.startDate}
        endDate={dateRange.endDate}
        focusedInput={dateRange.focus}
        onDatesChange={onDateChanged}
        onFocusChange={onFocusChanged}
      />
    </div>
  )
}

export default React.memo(LogsTableSubHeader);



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Logs/components/LogsTableSubHeader.tsx